import { callApiNew } from 'src/middleware/apiMiddleware';
import { getCurrentUserID } from 'src/utils/common';

const getLoggedInUserDetails = () =>
  callApiNew<User>({
    endpoint: `/user/${getCurrentUserID()}`,
    includeCommunityUuid: false,
  });

const updatePassword = (password: string, accessToken?: string, refreshToken?: string) =>
  callApiNew<User>({
    endpoint: `/password-update`,
    method: 'patch',
    headers: accessToken
      ? {
          Authorization: `Bearer ${accessToken}`,
          'X-CSRFToken': `${refreshToken}`,
        }
      : {},
    body: { password },
    authenticated: !accessToken,
    includeCommunityUuid: false,
  });

const apiUtil = {
  getLoggedInUserDetails,
  updatePassword,
};

export default apiUtil;
